import { parsePhoneNumberFromString } from "libphonenumber-js/max";

declare global {
    interface Window {
        libphonenumber?: {
            parsePhoneNumberFromString: typeof parsePhoneNumberFromString;
        };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any -- EPiServer client API is initialized at runtime with a dynamically structured object
        epi?: any;
    }
}

window.libphonenumber = {
    parsePhoneNumberFromString
};

(function () {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment -- EPiServer client API properties are added to window at runtime without TypeScript declarations
    const epi = window.epi || (window.epi = {});
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access -- EPiServer client API properties are added to window at runtime
    epi.EPiServer = epi.EPiServer || {};
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access -- EPiServer client API properties are added to window at runtime without TypeScript declarations
    epi.EPiServer.Forms = epi.EPiServer.Forms || {};
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access -- EPiServer client API properties are added to window at runtime without TypeScript declarations
    epi.EPiServer.Forms.Validators = epi.EPiServer.Forms.Validators || {};

    const keyPascal = "Securitas.PublicWeb.Web.Models.Elements.PhoneNumberValidator";
    const keyLower = keyPascal.toLowerCase();

    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- EPiServer validator metadata shape is runtime-defined
    function coreValidate(fieldName: string, fieldValue: string, validatorMetaData: any) {
        try {
            const candidateInputs = Array.from(
                document.querySelectorAll<HTMLInputElement>(`input[name='${fieldName}']`)
            );

            const input =
                candidateInputs.find((x) => (x.value || "").trim() === (fieldValue || "").trim()) ||
                candidateInputs.find((x) => x.offsetParent !== null) ||
                candidateInputs[0];

            const form = input?.closest("form") ?? null;
            const wrapper = input?.closest(".phone-input-wrapper") ?? null;

            const ccFromCustom =
                wrapper
                    ?.querySelector<HTMLElement>(".form-select .form-list li.selected[data-value]")
                    ?.dataset.value
                    ?.trim() ?? "";

            const ccFromNative =
                form?.querySelector<HTMLSelectElement>(`select[name='${fieldName}_cc']`)?.value?.trim() ??
                form?.querySelector<HTMLSelectElement>("select[name='countryCode']")?.value?.trim() ??
                "";

            const ccVal = ccFromCustom || ccFromNative;
            const local = (fieldValue || "").trim();

            // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access -- EPiServer validator metadata shape is defined at runtime, not statically typed
            const errorMessage = validatorMetaData?.model?.message || "Enter a valid phone number.";

            if (local === "") return { isValid: true };

            if (/[.\-\u2013\u2014\u2212]/.test(local)) {
                // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment -- EPiServer validator metadata shape is defined at runtime, not statically typed
                return { isValid: false, message: errorMessage };
            }

            const fullNumber = local.startsWith("+")
                ? local
                : "+" + ccVal.replace(/\D/g, "") + local.replace(/[^\d]/g, "");

             
            const parsed = window.libphonenumber?.parsePhoneNumberFromString(fullNumber);

             
            if (!parsed || !parsed.isValid()) {
                // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment -- EPiServer validator metadata shape is defined at runtime, not statically typed
                return { isValid: false, message: errorMessage };
            }

            return { isValid: true };
        } catch (e) {
            console.error("PhoneNumberValidator failed:", e);
            return { isValid: true };
        }
    }

    const validatorObject = { validate: coreValidate };

    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access -- EPiServer client API properties are added to window at runtime without TypeScript declarations
    epi.EPiServer.Forms.Validators[keyLower] = validatorObject;
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access -- EPiServer client API properties are added to window at runtime without TypeScript declarations
    epi.EPiServer.Forms.Validators[keyPascal] = validatorObject;
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access -- EPiServer client API properties are added to window at runtime without TypeScript declarations
    epi.EPiServer.Forms.Validators[keyLower + ":fn"] = coreValidate;
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access -- EPiServer client API properties are added to window at runtime without TypeScript declarations
    epi.EPiServer.Forms.Validators[keyPascal + ":fn"] = coreValidate;
})();